import { createSortOption } from '@nosto/preact'
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption('score', 'Osuvuus', { field: 'score', order: 'desc' }),
    createSortOption('date', 'Uusin ensin', { field: 'datePublished', order: 'asc' }),
    createSortOption('price', 'Hinta, nouseva', { field: 'price', order: 'asc' }),
    createSortOption('-price', 'Hinta, laskeva', { field: 'price', order: 'desc' }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 16,
    autocompleteKeywordsSize: 5,
    historySize: 5,
}
